import React from 'react';
import { Typography } from '@mui/material';

interface AgeIndicatorProps {
	days: number;
}

function getColor(days: number): string {
	if (days <= 7) return '#2e7d32';
	if (days <= 21) return '#e65100';
	return '#c62828';
}

export function AgeIndicator({ days }: AgeIndicatorProps): JSX.Element {
	const rounded = Math.floor(days);
	return (
		<Typography variant="body2" fontWeight={600} sx={{ color: getColor(days) }}>
			{rounded}d
		</Typography>
	);
}
